<template>
  <Slider class="ts-slider" tooltip-class="ts-slider-tooltip" v-bind="$attrs" v-on="$listeners"></Slider>
</template>

<style lang="scss" scoped>
.ts-slider::v-deep {
  .el-slider__bar {
    display: none;
  }

  .el-slider__button {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, #000000 0%, #ffffff 100%);
    background: #99ffd1;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
  }
}
</style>

<style lang="scss">
.ts-slider-tooltip.is-dark {
  background: #ebecf0 !important;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
  border-radius: 13px;

  font-family: Roboto;
  font-size: 10px;
  text-align: center;
  color: #acbacc;

  .popper__arrow {
    display: none;
  }
}
</style>

<script>
import { Slider } from 'element-ui';

export default {
  name: 'TsSlider',
  components: {
    Slider
  }
};
</script>
